import { RagFaq } from "@prisma/client";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import faqChatbotQueryKeys from "../query-keys/faq-chatbot.query-keys";
import {
  FilterFaqChatBotTypeWithPaginationAndSorting,
  PaginatedResponse,
} from "@ac-expo/api-types";

async function getFaqChatbot(
  filters: FilterFaqChatBotTypeWithPaginationAndSorting
) {
  const { data } = await privateAxios.get<PaginatedResponse<RagFaq>>(
    "/faq-chatbot",
    {
      params: filters,
    }
  );
  return data;
}

export const useGetFaqChatbotQuery = (
  filters: FilterFaqChatBotTypeWithPaginationAndSorting
) => {
  return useQuery({
    queryKey: faqChatbotQueryKeys.list(filters),
    queryFn: () => getFaqChatbot(filters),
  });
};
